import { IconInfoRegular } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

interface MaximumOrderTextProps {
  minimum_order_quantity: number;
  maximum_order_quantity: number | null;
  isPurchaseOnlyOneAtTime?: boolean;
}

export function OrderQuantityText({
  minimum_order_quantity,
  maximum_order_quantity,
  isPurchaseOnlyOneAtTime,
}: MaximumOrderTextProps) {
  const isMinimum = Boolean(minimum_order_quantity);
  const isMaximum = Boolean(maximum_order_quantity);
  const displaySlash = isMinimum && isMaximum;

  return (
    <Wrapper>
      <IconInfoRegular width={18} color='textSecondary' />
      <span>
        1인 {isMinimum && '최소'}
        {displaySlash && '/'}
        {isMaximum && '최대'} 구매수량 : {isMinimum && `${minimum_order_quantity}개`}
        {displaySlash && '/'}
        {isMaximum && `${maximum_order_quantity}개`}
      </span>
      {!isPurchaseOnlyOneAtTime && isMaximum && <small>(최근 30일 기준)</small>}
    </Wrapper>
  );
}

const Wrapper = styled.p`
  display: flex;
  align-items: center;
  padding-top: 4px;
  font-weight: 500;
  font-size: 13px;
  color: ${vars.v3Color.gray500};

  svg {
    height: 20px;
  }

  span {
    padding-left: 3px;
    padding-right: 2px;
  }

  small {
    font-size: 12px;
    color: ${vars.v3Color.gray400};
  }
`;
